export default "__VITE_ASSET__3de3600c__"